const eventsTrackingParams = ({
  originUrl,
  clientSessionId,
  category,
  action,
  label,
  value,
  nonInteraction,
  metadata,
  hitNumber,
}) => {
  if (category == null || action == null)
    throw new TypeError('category and action are required', 'trackEventProvider.js');

  return {
    clientSessionId,
    category,
    action,
    hitNumber,
    originUrl,
    label,
    value,
    nonInteraction,
    metadata,
  };
};

// this is also called from the widget where the logger dependency is not available
// eslint-disable-next-line no-console
const handleUnexpectedErrorFallback = err => console?.error(err);

const trackEventProvider = options => {
  const { baseUrl, windowObject, clientSessionId, jwt = null, widgetKey = null } = options;
  if (baseUrl == null || windowObject == null || clientSessionId == null)
    throw new TypeError(
      'baseUrl, windowObject, clientSessionId are required',
      'trackEventProvider.js'
    );

  const handleUnexpectedError = options.handleUnexpectedError || handleUnexpectedErrorFallback;
  let hitNumber = 1;

  return ({ category, action, label, value, nonInteraction, metadata }) => {
    const params = eventsTrackingParams({
      originUrl: windowObject.location.toString(),
      clientSessionId,
      category,
      action,
      label,
      value,
      nonInteraction,
      metadata,
      hitNumber: hitNumber++,
    });

    // stringify as sendBeacon does not accept json
    const paramsAsString = JSON.stringify(params);

    let serviceUrl = `${baseUrl}/api/v1/events`;

    if (widgetKey) serviceUrl = `${serviceUrl}?widgetKey=${encodeURIComponent(widgetKey)}`;

    const canUseBeaconApi = !jwt && windowObject.navigator.sendBeacon; // beacon api cannot be used with an Authorization header
    const beaconWasQueued =
      canUseBeaconApi && windowObject.navigator.sendBeacon(serviceUrl, paramsAsString);
    if (beaconWasQueued) return;

    // keep stringified params even when using fetch as crossDomain ajax call with text type
    // do not rrequire an OPTION http call
    const headers = {
      'Content-Type': 'text/plain',
      Accept: 'text/plain, application/json',
    };
    if (jwt) headers.Authorization = `Bearer ${jwt}`;

    windowObject
      .fetch(serviceUrl, {
        method: 'POST',
        body: paramsAsString,
        headers,
      })
      .catch(err => {
        handleUnexpectedError(err);
      });
  };
};

export default trackEventProvider;
